import { SnackbarContent, useSnackbar } from 'notistack';
import React, { forwardRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';

import { ICONS } from '../icons';
import Icon from '../icons/Icon';
import { openContactModal } from '../redux/global/globalReducer';

import './Notifications.scss';

const CommonNotification = forwardRef(
  (
    {
      id,
      message,
      subMessage,
      MarkerIcon,
      markerText,
      showMarkerText = true,
      markerStyle = 'default',
      messageParams = null,
      subMessageParams = null,
      subMessageWithContactLink = false,
    },
    ref,
  ) => {
    const { closeSnackbar } = useSnackbar();
    const { t } = useTranslation('notifications');
    const dispatch = useDispatch();

    const handleDismiss = useCallback(() => {
      closeSnackbar(id);
    }, [id, closeSnackbar]);

    const handleOpenContactModal = useCallback(() => {
      dispatch(openContactModal());
    }, [dispatch]);

    return (
      <SnackbarContent ref={ref} className={`snackbar_wrapper snackbar_wrapper--${markerStyle}`}>
        {MarkerIcon || markerText ? (
          <div className={`snackbar_marker snackbar_marker--${markerStyle}`}>
            {MarkerIcon ? (
              <Icon
                icon={MarkerIcon}
                className={`snackbar_marker_icon snackbar_marker_icon--${markerStyle}`}
                currentColor
                disableCommonColors
                disableCommonStyles
              />
            ) : null}
            {markerText && showMarkerText ? <span className='snackbar_marker_text'>{t(markerText)}</span> : null}
          </div>
        ) : null}
        <div className='snackbar_content'>
          <div className='snackbar_content--main-text'>{t(message, messageParams ? { ...messageParams } : null)}</div>
          {subMessage ? (
            <div className='snackbar_content--second-text'>
              {subMessageWithContactLink ? (
                <Trans
                  ns='notifications'
                  i18nKey={subMessage}
                  values={subMessageParams ? { ...subMessageParams } : undefined}
                  components={{
                    contactLink: (
                      <button type='button' className='snackbar_contact-link' onClick={handleOpenContactModal} />
                    ),
                  }}
                />
              ) : (
                t(subMessage, subMessageParams ? { ...subMessageParams } : null)
              )}
            </div>
          ) : null}
        </div>

        <div className='snackbar_actions'>
          <Icon icon={ICONS.Cross} onClick={handleDismiss} className='snackbar_actions_icon' disableCommonStyles />
        </div>
      </SnackbarContent>
    );
  },
);

CommonNotification.displayName = 'CommonNotification';

export default CommonNotification;
